module.exports = __webpack_public_path__ + "img/cr.1de00a62.png";